/**
 * i18n.js — Client-side translation helper
 *
 * Parses the JSON payload inlined by the server into <script id="__i18n__">
 * and exposes window.t(key, params) for translation lookups with placeholder
 * interpolation.
 *
 * Placeholder syntax matches Go's text/template style: {{.Name}}
 * Values are HTML-escaped to prevent XSS when interpolated.
 */
(function () {
  var msgs = {};

  function parseI18n() {
    var el = document.getElementById('__i18n__');
    if (!el) return;
    try {
      msgs = JSON.parse(el.textContent || el.innerText) || {};
    } catch (e) {
      msgs = {};
    }
  }

  // Parse immediately if DOM is already ready (e.g. script loaded deferred),
  // otherwise wait for DOMContentLoaded.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', parseI18n);
  } else {
    parseI18n();
  }

  /**
   * Translate a key with optional placeholder interpolation.
   *
   * @param {string} key - Translation key (e.g. "nav.logout")
   * @param {Object} [params] - Placeholder values (e.g. { Name: "Alice" })
   * @returns {string} Translated string, or key if not found
   */
  window.t = function (key, params) {
    var s = msgs[key];
    if (s === undefined || s === null) {
      return key;
    }
    if (params) {
      s = s.replace(/\{\{\.(\w+)\}\}/g, function (_, k) {
        var v = params[k] !== undefined ? String(params[k]) : '';
        return v
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      });
    }
    return s;
  };
})();
